module.exports = __webpack_public_path__ + "img/pic_features_2.1d3a84b6.png";